import { styled } from '@mui/system'

import { theme } from 'styles/theme'

export const Legend = styled('legend')(() => ({
  marginBottom: 9
}))

type LabelProps = {
  inputIsChecked?: boolean
}

const labelModifiers = {
  actived: {
    color: '#1e1e1e',
    background: theme.palette.primary.main,

    '& path': {
      fill: '#1e1e1e'
    },

    '&:hover': {
      background: theme.palette.primary[800]
    }
  },
  disabled: {
    color: '#AAA',
    background: '#FAFAFA',

    '& path': {
      fill: '#AAA'
    }
  }
}

export const Label = styled('label')<LabelProps>(({ inputIsChecked }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 21,
  transition: 'background 200ms',

  padding: '12px 15px',

  font: `normal ${inputIsChecked ? 600 : 400} 14px Inter, "sans-serif"`,

  '&:hover': {
    background: '#EAEAEA'
  },

  '&': {
    ...(inputIsChecked && labelModifiers.actived)
  }
}))

export const CheckboxWrapper = styled('div')(() => ({
  position: 'relative',

  '&:first-of-type label': {
    borderRadius: '8px 8px 0 0'
  },

  '&:last-of-type label': {
    borderRadius: '0 0 8px 8px'
  },

  '&:not(:last-of-type)': {
    borderBottom: '1px solid #D7D7D7'
  },

  '& input:not(:disabled) ~ label': {
    cursor: 'pointer'
  },

  '& input': {
    all: 'unset'
  },

  '& input[data-actived="false"]:focus ~ label': {
    background: '#56BB4D20'
  },

  '& input[data-actived="true"]:focus ~ label': {
    background: theme.palette.primary.main
  },

  '& input:disabled ~ label': {
    ...labelModifiers.disabled
  }
}))

export const ErrorLabel = styled('div')(() => ({
  background: '#ffebeb',
  padding: 14,
  borderRadius: 8,
  marginTop: 4,
  font: 'normal 400 14px Inter, sans-serif'
}))
